import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Icon,
} from '@bwoty-web/ui-kit';
import { ICON_WEATHER_SUN, ICON_WEATHER_MOON } from '@bwoty-web/ui-kit/icons';
import './climateWeatherNugget.scss';

const ClimateWeatherNugget = ({ month, day = '-', night = '-' }) => {
  const dayTempClasses = classNames('gw-weather-month__degree', {
    hidden: !day,
  });

  const nightTempClasses = classNames('gw-weather-month__degree', {
    hidden: !night,
  });

  const renderDegrees = (value, classes) => {
    if (value === undefined || value === null) {
      return <span className="gw-weather-month__fallback">-</span>;
    }
    return (
      <>
        {value}
        <span className={classes}>°</span>
      </>
    );
  };

  return (
    <div className="gw-weather-month">
      <h4 className="gw-weather-month__name">{month}</h4>
      <div className="gw-weather-month__temperatures-wrapper">
        <span className="gw-weather-month__temperature gw-weather-month__temperature--day">
          <Icon
            className="gw-weather-month__sun-icon"
            path={ICON_WEATHER_SUN}
            size="s"
            sizeMobile="xs"
          />
          <div>{renderDegrees(day, dayTempClasses)}</div>
        </span>
        <span className="gw-weather-month__temperature gw-weather-month__temperature--night">
          <Icon
            className="gw-weather-month__night-icon"
            path={ICON_WEATHER_MOON}
            size="s"
            sizeMobile="xs"
          />
          <div>{renderDegrees(night, nightTempClasses)}</div>
        </span>
      </div>
    </div>
  );
};

ClimateWeatherNugget.propTypes = {
  month: PropTypes.string.isRequired,
  day: PropTypes.number,
  night: PropTypes.number,
};

export default ClimateWeatherNugget;
